import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/LoginCSS.css';
import '../css/GeneralCSS.css';
import '../css/Text.css';
import '../css/Colors.css';

import LoginButton from '../BaseElements/Buttons/LoginButton';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AppContext } from '../AppContext';

axios.defaults.withCredentials = true;

function LoginPage() {
    const navigate = useNavigate();
    const { userId, checkSession, loadingSession } = useContext(AppContext);
    
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMess, setErrorMess] = useState('');
    const [, setIsMdOrLess] = useState(window.innerWidth <= 768);
    
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    useEffect(() => {
        if (loadingSession) return;
        if (userId) {
            navigate('/home');
        }
    }, [userId, loadingSession, navigate]);
    
    const handleResize = () => {
        setIsMdOrLess(window.innerWidth < 768);
    };
    
    const login = async (event) => {
        event.preventDefault();
        setShowError(false);
        
        if (!username || !password) {
            setErrorMess("Per favore inserisci username e password");
            setShowError(true);
            return;
        }
        
        const axiosConfig = {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            },
        };
        
        try {
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/caregiverLogin`, {
                username,
                password,
            }, axiosConfig);
            
            if (response.data.success) {
                await checkSession();
            } else {
                setErrorMess(response.data.errorMess || 'Credenziali non valide');
                setShowError(true);
            }
        } catch (error) {
            setErrorMess("Errore del server o di rete.");
            setShowError(true);
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div className='generalBackground'>
            <div className='loginImageCol'>
                <div className='loginImage' />
            </div>
            <div className='loginFormCol'>
                <div className='loginComponent'>
                    <form className='loginForm' onSubmit={login}>
                        <p className='loginWelcomeText'>Bentornato!</p>
                        <label className='loginLabelText'>User ID</label>
                        <input className='loginInputArea' onChange={e => setUsername(e.target.value)} />
                        <label className='loginLabelText'>Password</label>
                        <input className="loginInputArea" type="password" onChange={e => setPassword(e.target.value)} />
                        <LoginButton loading={isLoading} />
                    </form>
                    {showError && <p className='errorMessage'>{errorMess}</p>}
                </div>
            </div>
        </div>
    );
}

export default LoginPage;